// GENERATED from irecommend_Terms_of_Use_Final_2026-09-15.docx
//
// The authoritative, locked document, transcribed mechanically from the supplied
// DOCX so that no wording, heading, number, list item or ordering can drift.
// Do not edit this file by hand: it is legal text, not copy.
export const termsOfUse = {
  "title": "irecommend Terms of Use",
  "effectiveDate": "Effective date: 15 September 2026",
  "sections": [
    {
      "heading": "1. About these Terms",
      "blocks": [
        {
          "type": "paragraph",
          "text": "These Terms apply when you access or use irecommend."
        },
        {
          "type": "paragraph",
          "text": "irecommend is a private recommendation service operated by Tautua Tech Limited, a New Zealand company (NZBN 9429053458445)."
        },
        {
          "type": "paragraph",
          "text": "By creating an account or using irecommend, you agree to these Terms. You should also read our Privacy Statement, which explains how we handle personal information."
        },
        {
          "type": "paragraph",
          "text": "If you do not agree to these Terms, you should not create an account or use irecommend."
        },
        {
          "type": "paragraph",
          "text": "If you have questions about these Terms, contact us at phillip@tautuatech.com."
        }
      ]
    },
    {
      "heading": "2. Eligibility",
      "blocks": [
        {
          "type": "paragraph",
          "text": "You must be at least 13 years old to use irecommend."
        },
        {
          "type": "paragraph",
          "text": "irecommend is currently an invite-only service. You need a valid invitation to create an account."
        },
        {
          "type": "paragraph",
          "text": "Invitation links are not tied to a particular recipient. The person sending an invitation decides who to share it with, but anyone who obtains a valid unused invitation link may be able to use it to join irecommend."
        },
        {
          "type": "paragraph",
          "text": "You must not create or use an account if doing so would be prohibited by applicable law."
        }
      ]
    },
    {
      "heading": "3. Your account",
      "blocks": [
        {
          "type": "paragraph",
          "text": "You must provide accurate account information and keep it reasonably up to date."
        },
        {
          "type": "paragraph",
          "text": "You are responsible for keeping your password and other login information secure and for activity occurring through your account."
        },
        {
          "type": "paragraph",
          "text": "You must not allow another person to use your account or access another person's account without permission."
        },
        {
          "type": "paragraph",
          "text": "If you believe your account or login information has been compromised or used without your permission, contact us at phillip@tautuatech.com."
        },
        {
          "type": "paragraph",
          "text": "Your email address identifies your account and is used for signing in. You are responsible for ensuring that the email address associated with your account belongs to you and that your account information remains accurate."
        }
      ]
    },
    {
      "heading": "4. How irecommend works",
      "blocks": [
        {
          "type": "paragraph",
          "text": "irecommend allows you to create, save and discover recommendations from other irecommend users."
        },
        {
          "type": "paragraph",
          "text": "When you create a recommendation, you can choose who it is available to through the visibility options provided by irecommend. Depending on the option you choose, your recommendation may be available only to your connections or more widely to other signed-in irecommend users."
        },
        {
          "type": "paragraph",
          "text": "Recommendations shared more widely are not made available as a public web page simply because you choose that visibility. Access remains subject to irecommend's service and access controls."
        },
        {
          "type": "paragraph",
          "text": "You can choose whether your browsing experience is limited to recommendations from people you trust or includes recommendations shared more widely through irecommend. Your browsing preference is separate from the visibility you choose for recommendations you create."
        },
        {
          "type": "paragraph",
          "text": "Connections are established through irecommend's invitation system. A connection allows each person to see recommendations the other has made available to their connections, subject to the visibility settings and features available at the time."
        },
        {
          "type": "paragraph",
          "text": "You may save recommendations that are available to you for later reference. Saving a recommendation does not change who owns it or its visibility."
        },
        {
          "type": "paragraph",
          "text": "The availability of a recommendation may change if its author changes its visibility, deletes it or deletes their account, if a connection is removed, or if Tautua Tech restricts or removes the recommendation in accordance with these Terms."
        }
      ]
    },
    {
      "heading": "5. Recommendations and other content",
      "blocks": [
        {
          "type": "paragraph",
          "text": "You are responsible for recommendations and other content you provide through irecommend. You should have the right to share that content and reasonably believe that what you say is genuine and accurate."
        },
        {
          "type": "paragraph",
          "text": "Recommendations reflect the views of the users who create them. Tautua Tech Limited does not verify or endorse a recommendation merely because it appears on irecommend."
        },
        {
          "type": "paragraph",
          "text": "You retain ownership of content you create."
        },
        {
          "type": "paragraph",
          "text": "By providing content through irecommend, you give Tautua Tech Limited a non-exclusive, worldwide, royalty-free licence to host, store, reproduce, display and process that content as reasonably necessary to operate, provide, secure and improve irecommend and to make the content available through the features and visibility options you choose."
        },
        {
          "type": "paragraph",
          "text": "This licence does not transfer ownership of your content to Tautua Tech Limited. It ends when the content is deleted from the live service, except to the extent that copies remain temporarily in backups or limited retention is otherwise necessary or lawful."
        },
        {
          "type": "paragraph",
          "text": "You may edit or delete recommendations you have created through the features provided by irecommend."
        }
      ]
    },
    {
      "heading": "6. Other people's privacy",
      "blocks": [
        {
          "type": "paragraph",
          "text": "You must respect other people's privacy when using irecommend."
        },
        {
          "type": "paragraph",
          "text": "Do not include sensitive personal information about another person in a recommendation, including information about their health, finances, private relationships or other matters they would reasonably expect to remain private."
        },
        {
          "type": "paragraph",
          "text": "You should avoid including other personal information about another person unless it is reasonably necessary and you have a legitimate reason to do so."
        },
        {
          "type": "paragraph",
          "text": "You must not use irecommend to disclose information about another person unlawfully or in a way intended to harass, embarrass, threaten or intimidate them."
        },
        {
          "type": "paragraph",
          "text": "If you believe content on irecommend improperly contains your personal information, contact us at phillip@tautuatech.com."
        }
      ]
    },
    {
      "heading": "7. Prohibited content and behaviour",
      "blocks": [
        {
          "type": "paragraph",
          "text": "You must use irecommend lawfully and respectfully."
        },
        {
          "type": "paragraph",
          "text": "You must not use irecommend to create, upload, share, link to, direct people to or promote content that:"
        },
        {
          "type": "list",
          "items": [
            "is unlawful, fraudulent, deceptive or materially misleading;",
            "threatens, abuses, harasses or intimidates another person;",
            "promotes hatred or unlawful discrimination;",
            "infringes another person's intellectual property, privacy or other legal rights;",
            "improperly discloses sensitive or private information;",
            "contains malicious software or other harmful code;",
            "constitutes spam or is intended to manipulate, disrupt or misuse the service; or",
            "would otherwise breach these Terms if the content itself were posted directly on irecommend."
          ]
        },
        {
          "type": "paragraph",
          "text": "You must not interfere with the operation or security of irecommend, attempt to gain unauthorised access to accounts, systems or data, scrape or harvest information from the service, or otherwise use irecommend in a way that materially harms the service or its users."
        },
        {
          "type": "paragraph",
          "text": "Tautua Tech Limited may reasonably investigate suspected breaches and, where appropriate, restrict access, remove content or terminate accounts in accordance with these Terms."
        }
      ]
    },
    {
      "heading": "8. Third-party content and links",
      "blocks": [
        {
          "type": "paragraph",
          "text": "Recommendations and other user content may refer or link to third-party businesses, services, products, websites or other content."
        },
        {
          "type": "paragraph",
          "text": "A reference or link does not mean that Tautua Tech Limited endorses, verifies or controls the third party or its content."
        },
        {
          "type": "paragraph",
          "text": "Third-party websites and services operate independently of irecommend and may have their own terms, privacy practices and security risks. You are responsible for deciding whether to visit, use or rely on them."
        },
        {
          "type": "paragraph",
          "text": "To the extent permitted by law, Tautua Tech Limited is not responsible for the availability, accuracy, security or content of third-party websites or services merely because they are referred to or linked through irecommend."
        }
      ]
    },
    {
      "heading": "9. Commercial recommendations and conflicts of interest",
      "blocks": [
        {
          "type": "paragraph",
          "text": "Recommendations should be genuine."
        },
        {
          "type": "paragraph",
          "text": "If you have a material personal or commercial relationship with a business, product or service you recommend, you should disclose that relationship where it could reasonably affect how another user understands the recommendation."
        },
        {
          "type": "paragraph",
          "text": "You must not present paid, sponsored or incentivised content as an independent personal recommendation."
        },
        {
          "type": "paragraph",
          "text": "You must not use irecommend primarily for unsolicited advertising, spam or misleading promotion."
        },
        {
          "type": "paragraph",
          "text": "A business owner, employee or other person associated with a business may recommend its products or services provided they do not misrepresent their relationship with the business."
        }
      ]
    },
    {
      "heading": "10. Connections, invitations and sharing",
      "blocks": [
        {
          "type": "paragraph",
          "text": "Connections are created through irecommend's invitation system."
        },
        {
          "type": "paragraph",
          "text": "Invitation links are not tied to a specific recipient. You should only share an invitation link with people you intend to invite. Anyone who obtains a valid unused invitation link may be able to use it."
        },
        {
          "type": "paragraph",
          "text": "Either person may remove a connection. If a connection is removed, recommendations that were available to you because of that connection will cease to be available through that connection."
        },
        {
          "type": "paragraph",
          "text": "irecommend may provide features allowing recommendations to be shared outside the service. When you share another user's recommendation using irecommend's sharing feature, that user's identity is not included in the shared recommendation."
        },
        {
          "type": "paragraph",
          "text": "People who legitimately have access to a recommendation may nevertheless be able to copy, screenshot or otherwise share it. Tautua Tech Limited cannot completely control what another person does with content after they have legitimately accessed it."
        }
      ]
    },
    {
      "heading": "11. Saving recommendations",
      "blocks": [
        {
          "type": "paragraph",
          "text": "You may save recommendations available to you for later reference."
        },
        {
          "type": "paragraph",
          "text": "Saving a recommendation does not create a separate permanent copy of that recommendation."
        },
        {
          "type": "paragraph",
          "text": "A saved recommendation may cease to be available if the author deletes it or their account, or if the relationship or visibility that allowed you to access it changes."
        },
        {
          "type": "paragraph",
          "text": "Tautua Tech Limited does not guarantee that a saved recommendation will remain available indefinitely."
        }
      ]
    },
    {
      "heading": "12. Moderation, suspension and termination",
      "blocks": [
        {
          "type": "paragraph",
          "text": "Tautua Tech Limited may investigate content, activity or accounts where we reasonably believe that:"
        },
        {
          "type": "list",
          "items": [
            "these Terms may have been breached;",
            "a person may be at risk of harm;",
            "action may be required by law; or",
            "the security or integrity of irecommend may be at risk."
          ]
        },
        {
          "type": "paragraph",
          "text": "Where reasonably appropriate, we may remove or restrict content, restrict or suspend access to irecommend, or terminate an account."
        },
        {
          "type": "paragraph",
          "text": "In deciding what action is appropriate, we may consider the seriousness of the issue, available alternatives, relevant previous conduct and our legal obligations."
        },
        {
          "type": "paragraph",
          "text": "Where reasonably practicable and appropriate, we will try to notify you of significant action affecting your account and provide a general reason for the action."
        },
        {
          "type": "paragraph",
          "text": "We may act without prior notice where reasonably necessary to protect users or the service, comply with law, address an urgent issue or prevent harm."
        },
        {
          "type": "paragraph",
          "text": "You may contact us at phillip@tautuatech.com if you wish to report a possible breach of these Terms or raise a concern about moderation action."
        }
      ]
    },
    {
      "heading": "13. Deleting your account",
      "blocks": [
        {
          "type": "paragraph",
          "text": "You may delete your account using the account-deletion feature provided through irecommend."
        },
        {
          "type": "paragraph",
          "text": "Account deletion is intended to be permanent. When your account is deleted, you will lose access to it, your recommendations will be removed from the live service, and your connections and saved recommendations will be affected."
        },
        {
          "type": "paragraph",
          "text": "Recommendations you created will no longer remain available through other users' Saved recommendations."
        },
        {
          "type": "paragraph",
          "text": "Limited information may remain temporarily in backups or be retained for security, system integrity, legal or operational purposes as described in the Privacy Statement."
        },
        {
          "type": "paragraph",
          "text": "If your account is involved in an existing moderation report or complaint, deleting your account does not necessarily result in the immediate deletion of that moderation record. Limited information may be retained and de-identified where appropriate for the purposes and retention periods described in the irecommend Privacy Statement."
        }
      ]
    },
    {
      "heading": "14. Intellectual property",
      "blocks": [
        {
          "type": "paragraph",
          "text": "You retain ownership of content you create, subject to the licence in Section 5."
        },
        {
          "type": "paragraph",
          "text": "Tautua Tech Limited owns or has the necessary rights to the irecommend name, branding, design, software and other materials used to provide the service, except where those rights belong to third parties."
        },
        {
          "type": "paragraph",
          "text": "Using irecommend does not transfer ownership of those rights to you or give you a right to use irecommend's branding, software or other proprietary material outside the service."
        },
        {
          "type": "paragraph",
          "text": "You must respect the intellectual property rights of other people."
        }
      ]
    },
    {
      "heading": "15. Recommendations are not endorsements or guarantees",
      "blocks": [
        {
          "type": "paragraph",
          "text": "Recommendations on irecommend are the opinions, experiences and views of individual users."
        },
        {
          "type": "paragraph",
          "text": "Tautua Tech Limited does not independently verify, approve or endorse the product, service, place, activity, content or other subject of a recommendation."
        },
        {
          "type": "paragraph",
          "text": "We do not guarantee that you will have the same experience as another user or that information contained in a recommendation remains accurate or current."
        },
        {
          "type": "paragraph",
          "text": "You are responsible for deciding whether to act on a recommendation and for making any enquiries or checks you consider appropriate."
        },
        {
          "type": "paragraph",
          "text": "Nothing in this section limits rights you may have under applicable law."
        }
      ]
    },
    {
      "heading": "16. Service availability and changes",
      "blocks": [
        {
          "type": "paragraph",
          "text": "We aim to provide a reliable service, but we do not guarantee that irecommend will always be available, uninterrupted or error-free."
        },
        {
          "type": "paragraph",
          "text": "The service may occasionally be unavailable because of maintenance, technical problems, security issues or circumstances outside our reasonable control."
        },
        {
          "type": "paragraph",
          "text": "We may update irecommend or add, change or remove features. Where reasonably practicable, we will provide notice of material changes that significantly affect users or their rights."
        },
        {
          "type": "paragraph",
          "text": "Changes to the service or these Terms do not remove rights that cannot lawfully be excluded."
        }
      ]
    },
    {
      "heading": "17. Liability",
      "blocks": [
        {
          "type": "paragraph",
          "text": "Nothing in these Terms excludes, restricts or modifies any right or remedy you have under the Consumer Guarantees Act 1993, the Fair Trading Act 1986, or any other law where that right or remedy cannot lawfully be excluded, restricted or modified."
        },
        {
          "type": "paragraph",
          "text": "To the extent permitted by law, Tautua Tech Limited is not responsible for loss or harm resulting from:"
        },
        {
          "type": "list",
          "items": [
            "content created or shared by users;",
            "decisions you make in reliance on a recommendation;",
            "the acts or omissions of third parties;",
            "third-party websites, products or services;",
            "another user's unauthorised copying, sharing or use of content after that user legitimately obtained access to it; or",
            "events outside our reasonable control."
          ]
        },
        {
          "type": "paragraph",
          "text": "Where Tautua Tech Limited is legally responsible for loss or harm, our liability will be determined in accordance with applicable law."
        },
        {
          "type": "paragraph",
          "text": "Nothing in these Terms excludes or limits liability where doing so would be unlawful."
        }
      ]
    },
    {
      "heading": "18. Changes to these Terms",
      "blocks": [
        {
          "type": "paragraph",
          "text": "We may update these Terms as irecommend, our practices or applicable law change."
        },
        {
          "type": "paragraph",
          "text": "When we update them, we will update the effective date."
        },
        {
          "type": "paragraph",
          "text": "Where a change materially affects your rights or obligations, we will take reasonable steps to bring the change to your attention."
        },
        {
          "type": "paragraph",
          "text": "If you continue using irecommend after updated Terms take effect, the updated Terms will apply to your continued use. If you do not agree with an update, you may stop using irecommend and delete your account."
        },
        {
          "type": "paragraph",
          "text": "Nothing in this section limits rights you have under applicable law."
        }
      ]
    },
    {
      "heading": "19. Governing law",
      "blocks": [
        {
          "type": "paragraph",
          "text": "These Terms are governed by the laws of New Zealand."
        },
        {
          "type": "paragraph",
          "text": "Nothing in these Terms prevents you from exercising any rights or remedies available to you under applicable law."
        }
      ]
    },
    {
      "heading": "20. Contact",
      "blocks": [
        {
          "type": "paragraph",
          "text": "If you have questions about these Terms, want to report a possible breach, or need to contact us about your use of irecommend, contact:"
        },
        {
          "type": "lines",
          "lines": [
            "Tautua Tech Limited",
            "NZBN 9429053458445",
            "Email: phillip@tautuatech.com"
          ]
        },
        {
          "type": "paragraph",
          "text": "irecommend is operated by Tautua Tech Limited in New Zealand."
        }
      ]
    }
  ]
};
